var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "\nexpand  ", _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40174 5.18322L11.8591 9.19452C12.047 9.36338 12.047 9.63618 11.8591 9.80548L7.40174 13.8168C7.13062 14.0611 6.6895 14.0611 6.41789 13.8168C6.14677 13.5725 6.14677 13.176 6.41789 12.9317L10.231 9.49978L6.41789 6.06872C6.14677 5.82399 6.14677 5.42751 6.41789 5.18322C6.6895 4.93893 7.13061 4.93893 7.40174 5.18322Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.a4286d476a97022001c2fd352bb74975.svg";
export { ForwardRef as ReactComponent };